<template>
    <a-card hoverable class="admin-card">
        <template #title>
            <div class="card-header">
                <div class="card-title" :style="color ? { '--title-color': color } : {}">
                    <!-- 如果有颜色属性，显示颜色圆点 -->
                    <span v-if="color" class="color-dot" :style="{ backgroundColor: color }"></span>
                    {{ title }}
                </div>
                <div class="card-actions">
                    <slot name="actions"></slot>
                </div>
            </div>
        </template>

        <div class="card-content">
            <!-- 如果有自定义内容槽，则使用自定义内容 -->
            <slot>
                <!-- 默认内容结构 -->
                <div class="card-description">
                    {{ description || '暂无描述' }}
                </div>
            </slot>
            <div class="card-meta">
                <slot name="meta"></slot>
            </div>
        </div>
    </a-card>
</template>

<script>
export default {
    name: 'AdminCard',
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.admin-card {
    height: 100%;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.admin-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.admin-card :deep(.ant-card) {
    height: auto;
}

/* 重写Ant Design卡片的默认样式 */
.admin-card :deep(.ant-card-head) {
    padding: 8px 12px 4px 12px;
    border-bottom: none;
    min-height: auto;
}

.admin-card :deep(.ant-card-body) {
    padding: 4px 12px 8px 12px;
}

/* 卡片头部 */
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 2px;
}

.card-title {
    font-weight: 600;
    font-size: 16px;
    margin: 0;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--title-color, #1890ff);
}

.color-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}

/* 卡片操作按钮 */
.card-actions {
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s;
}

.admin-card:hover .card-actions {
    opacity: 1;
}

/* 卡片内容 */
.card-content {
    margin-top: 0;
    padding: 0;
}

.card-description {
    color: #666;
    margin-bottom: 6px;
    line-height: 1.4;
    font-size: 14px;
}

.card-meta {
    margin-top: 6px;
}

.card-meta :deep(.ant-typography) {
    font-size: 12px;
    color: #999;
}
</style>